import ErrorBoundaryForSection from "../../components/errorBoundaryForSection";
import ChatAsideColumn from "./components/chatAsideColumn";
import ChatMainColumn from "./components/chatMainColumn";
import SMSAsideColumn from "./components/smsAsideColumn";
import SMSMainColumn from "./components/smsMainColumn";
import { useChatContext } from "./contexts/chat.context";
import ModalCreateNewChatGroup from "./modalCreateNewGroupChat";
import ModalCreateNewSMSGroup from "./modalCreateNewGroupSMS";

const MessagingMainSection = () => {
  const { messagingMode } = useChatContext();
  return (
    <>
      {messagingMode === "chat" ? (
        <>
          <div className="grid grid-cols-12 gap-4 h-[calc(100vh-160px)] overflow-hidden">
            <ErrorBoundaryForSection wrapClass="col-span-4 h-[calc(100vh-160px)]">
              <ChatAsideColumn wrapperClass="col-span-4 flex flex-col h-[calc(100vh-160px)]" />
            </ErrorBoundaryForSection>
            <ChatMainColumn />
          </div>
          <ModalCreateNewChatGroup />
        </>
      ) : (
        <>
          <div className="grid grid-cols-12 gap-4 h-[calc(100vh-160px)] overflow-hidden">
            <SMSAsideColumn wrapperClass="col-span-4 flex flex-col h-[calc(100vh-160px)]" />
            <SMSMainColumn />
          </div>
          <ModalCreateNewSMSGroup />
        </>
      )}
    </>
  );
};
export default MessagingMainSection;
